//@ts-nocheck
import React from 'react';
import styled from 'styled-components';

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 5px;
`;

const PageButton = styled.button`
  min-width: 35px;
  height: 35px;
  border: 1px solid #dee2e6;
  background: ${(props) => (props.active ? '#007bff' : 'white')};
  color: ${(props) => (props.active ? 'white' : '#007bff')};
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  &:hover {
    background: ${(props) =>
      props.disabled
        ? props.active
          ? '#007bff'
          : 'white'
        : props.active
        ? '#0056b3'
        : '#e9ecef'};
  }
`;

const PageInfo = styled.span`
  margin: 0 15px;
  color: #6c757d;
  font-size: 14px;
`;

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
}) => {
  const generatePaginationItems = () => {
    const items = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(
      1,
      currentPage - Math.floor(maxVisiblePages / 2),
    );
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Previous button
    items.push(
      <PageButton
        key="prev"
        disabled={currentPage === 1}
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
      >
        ‹
      </PageButton>,
    );

    // First page
    if (startPage > 1) {
      items.push(
        <PageButton key={1} onClick={() => onPageChange(1)}>
          1
        </PageButton>,
      );
      if (startPage > 2) {
        items.push(<span key="ellipsis1">...</span>);
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <PageButton
          key={i}
          active={i === currentPage}
          onClick={() => onPageChange(i)}
        >
          {i}
        </PageButton>,
      );
    }

    // Last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(<span key="ellipsis2">...</span>);
      }
      items.push(
        <PageButton
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </PageButton>,
      );
    }

    // Next button
    items.push(
      <PageButton
        key="next"
        disabled={currentPage === totalPages}
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
      >
        ›
      </PageButton>,
    );

    return items;
  };

  if (totalPages <= 1) return null;

  return (
    <PaginationWrapper>
      {generatePaginationItems()}
      {totalItems && (
        <PageInfo>
          Strona {currentPage} z {totalPages} ({totalItems} elementów)
        </PageInfo>
      )}
    </PaginationWrapper>
  );
};

export default Pagination;
